import { createSlotRecipe } from './runtime.js';

const flipCardConfig = {"name":"flipCard","className":"flip-card","slots":["root","rotator","face","front","back","edge","topEdge","rightEdge","bottomEdge","leftEdge","corner","cornerPart","topRightCorner","bottomRightCorner","bottomLeftCorner","topLeftCorner"]}

export const flipCard = /* @__PURE__ */ createSlotRecipe(flipCardConfig)